import $ from 'jquery';

/**
 * @fileoverview To display easter egg branding information in console log
 */
(() => {
  const { appDomainId } = $('#h24-client').data();
  let consoleAlias = window.console;

  if (!consoleAlias || !consoleAlias.log || appDomainId === 8) {
    return undefined;
  }
  const message = `%c
                                                             
                                                                
                            \`..------..\`                        
                      \`-:/+oooooooooooooo+/:-\`                  
                  \`-/+oooooooooooooooooooooooo+/-\`              
                -/oooooooooooooooooooooooooooooooo/-            
             \`:+oooooooooooooooooooooooooooooooooooo+:\`         
            -+oooooooooooooooooooooooooooooooooooooooo+-        
          \`+ooooooooooooooooooooooooooo:..-ooooooo+/oooo/\`      
         .ooooooo+/:-...-:+oooooooooo+\`    +oooo+.  \`oooo+.     
        -ooooo+:.    \`     :oooooooo+\`    \`oooo+\`    +ooooo.    
       .oooo+-    -/oo+\`    /oooooo+\`     /oooo-     +oooooo.   
       +oooo/-.--+ooooo:    .oooooo.     -oooo+     -ooooooo+   
      -oooooooooooooooo.    .ooooo:     .ooooo-     +oooooooo-  
      +ooooooooooooooo/     :oooo+     \`+oooo+     .ooooooooo/  
      ooooooooooooooo+\`    \`ooooo-     /ooooo:     -:--..-:+oo  
     \`oooooooooooooo+\`    \`+oooo+     \`++//:-\`     .-::://:+oo\` 
      ooooooooooooo/     \`+ooooo+         \`..     .ooooooooooo  
      +ooooooooooo:     \`+ooooooo+:::://+ooo:     /oooooooooo+  
      -oooooooooo-     \`+ooooooooooooooooooo.     +oooooooooo-  
       +ooooooo+.     .+oooooooooooooooooooo\`    .oooooooooo+   
       .oooooo+\`     .ooooooooooooooooooooo+     /oooooooooo.   
        -ooooo.     -ooo++//:-...\`\`.-:+oooo/    .oooooooooo-    
         -oooo.     \`\`\`    \`\`.------../oooo+   -oooooooooo.     
          \`+ooo+:----::/++oooooooooooooooooo++oooooooooo+\`      
            -ooooooooooooooooooooooooooooooooooooooooo+-        
             \`:+oooooooooooooooooooooooooooooooooooo+:\`         
                -+oooooooooooooooooooooooooooooooo/-            
                  \`-/oooooooooooooooooooooooooo/-\`              
                      .-:++oooooooooooooo+/:-.                  
                           \`\`..------..\`\`                       
                                                                
%c
 _       _         _                 _
( )  _  ( )       ( )               ( )     _        _
| | ( ) | |   __  |/  _ __   __     | |__  (_) _ __ (_)  ___     __
| | | | | | /'__\`\\   ( '__)/'__\`\\   |  _ \`\\| |( '__)| |/' _ \`\\ /'_ \`\\
| (_/ \\_) |(  ___/   | |  (  ___/   | | | || || |   | || ( ) |( (_) |
\`\\___x___/'\`\\____)   (_)  \`\\____)   (_) (_)(_)(_)   (_)(_) (_)\`\\__  |
                                                              ( )_) |
                                                               \\___/'

Check out the open positions in our Berlin office at %chttp://www.home24.de/jobs%c


`;

  consoleAlias.log(
    message,
    'color: #f5674c',
    'color: #354044',
    'color: #f5674c',
    'color: #354044'
  );

  return undefined;
})();



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/consoleBranding.js
 **/